module.exports = __webpack_public_path__ + "static/img/thumb-01.eeebecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/dhl/thumb/thumb-01.png
// module id = Nqnx
// module chunks = 31